/**
 * AdminNotFound — branded 404 for an unmatched route INSIDE the firm console
 * shell (/admin/*). Mirrors `portal-not-found.tsx` (the /app equivalent) but
 * renders the firm-chrome `AdminLayout` (sidebar + topbar) instead of the
 * client-portal `ScreenShell`, so a mistyped /admin/* URL keeps the firm's
 * own branding + nav instead of dropping to a bare page or the marketing
 * shell.
 *
 * 2026-07-11 (firm-chair rehearsal, P3 #27): a mistyped /admin/* URL rendered
 * TanStack Router's bare, unstyled "Not Found" fallback — the root
 * `notFoundComponent` (`error-pages/not-found.tsx`) never fires for a route
 * nested under `/admin` (TanStack resolves the nearest matched ANCESTOR
 * route as the not-found boundary), and `routes/admin/_layout.tsx` had no
 * `notFoundComponent` of its own. A branded `PortalNotFound` already existed
 * for `/app/*` (same finding, individual side) — this is its firm-console
 * twin.
 *
 * Wiring (NOT done in this file — `routes/admin/_layout.tsx` is owned by a
 * concurrent wave): add to that route's `createFileRoute('/admin')({...})`
 * config, exactly mirroring `routes/app/_layout.tsx`:
 *
 *   notFoundComponent: () => <AdminNotFound />,
 */

import { Link } from '@tanstack/react-router';
import { AdminLayout } from '../layouts/admin-layout';

export function AdminNotFound() {
  return (
    <AdminLayout eyebrow="Not found" title={<>We can&rsquo;t find that page</>}>
      <div className="card" style={{ padding: 24, maxWidth: 560 }}>
        <p style={{ color: 'var(--ink-3)', margin: '0 0 16px', lineHeight: 1.6 }}>
          The page you were looking for doesn&rsquo;t exist, or has moved.
          Nothing about your firm&rsquo;s data has changed. It&rsquo;s safe.
        </p>
        <Link
          to="/admin/dashboard"
          style={{
            fontSize: 14.5,
            fontWeight: 600,
            color: 'var(--primary-600)',
            textDecoration: 'none',
            borderBottom: '1px solid rgba(31,77,69,0.25)',
            paddingBottom: 1,
          }}
        >
          Back to dashboard
        </Link>
      </div>
    </AdminLayout>
  );
}
